import type {
  EdoAbonentsResponse,
  IntegrationSettingsDto,
  IntegrationSettingsRequest,
  IntegrationsTestResponse,
  LookupCompanyResponse,
} from '@expeditor/shared';
import { apiClient } from './client';

export const integrationsApi = {
  async getSettings(): Promise<IntegrationSettingsDto> {
    const { data } = await apiClient.get<IntegrationSettingsDto>('/admin/integrations');
    return data;
  },
  async updateSettings(dto: IntegrationSettingsRequest): Promise<IntegrationSettingsDto> {
    const { data } = await apiClient.put<IntegrationSettingsDto>('/admin/integrations', dto);
    return data;
  },
  async testDadata(): Promise<IntegrationsTestResponse> {
    const { data } = await apiClient.post<IntegrationsTestResponse>(
      '/admin/integrations/dadata/test',
    );
    return data;
  },
  async testEdo(env?: 'test' | 'prod'): Promise<IntegrationsTestResponse> {
    const { data } = await apiClient.post<IntegrationsTestResponse>(
      '/admin/integrations/edo/test',
      undefined,
      { params: env ? { env } : undefined },
    );
    return data;
  },
};

/** Поиск абонента ЭДО по ИНН — для кнопки «Найти» в карточке лица. */
export const edoApi = {
  async findAbonents(inn: string, kpp?: string): Promise<EdoAbonentsResponse> {
    const { data } = await apiClient.get<EdoAbonentsResponse>('/edo/abonents', {
      params: { inn, ...(kpp ? { kpp } : {}) },
    });
    return data;
  },
};

export const lookupApi = {
  async company(query: string): Promise<LookupCompanyResponse> {
    const { data } = await apiClient.post<LookupCompanyResponse>('/lookup/company', { query });
    return data;
  },
};
